import script from "./CategoryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryList.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryList.vue?vue&type=style&index=0&id=1d174b27&scoped=true&lang=postcss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d174b27"]])

export default __exports__